import { Helmet } from "react-helmet-async";

const structuredData = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://www.laimesdieta.lt/#organization",
      name: "Laimės Dieta",
      url: "https://www.laimesdieta.lt",
      logo: "https://www.laimesdieta.lt/images/laimes-dieta-logo-2026.png",
      description: "Laimės Dieta – moterų saviugdos platforma, orientuota į emocinį augimą, ritualus ir savivertę.",
      foundingDate: "2023",
      areaServed: {
        "@type": "Country",
        name: "Lithuania",
      },
      sameAs: [],
      founder: {
        "@type": "Person",
      "@id": "https://www.laimesdieta.lt/#founder",
        name: "Rimantė",
        jobTitle: "Įkūrėja",
        worksFor: { "@id": "https://www.laimesdieta.lt/#organization" },
      },
    },
    {
      "@type": "WebSite",
      "@id": "https://www.laimesdieta.lt/#website",
      url: "https://www.laimesdieta.lt",
      name: "Laimės Dieta",
      publisher: { "@id": "https://www.laimesdieta.lt/#organization" },
      inLanguage: ["lt", "en"],
    },
  ],
};

const StructuredData = () => (
  <Helmet>
    <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
  </Helmet>
);

export default StructuredData;
